import React,{useState,useEffect} from 'react';
import {Avatar,Card,Col,Row,List} from 'antd';
import {NavLink} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next';

const {Meta} = Card;

function WorkflowPage(props){

	const [profile,setProfile] = useState([]);
	const {t} = useTranslation();

	useEffect(()=>{
		var profile = JSON.parse(JSON.stringify(props.userProfile.endpoints));
		var profile_keys = Object.keys(profile);
		var profile_array = Object.values(profile);
		profile_array.forEach(function(p,i){
			p.namespace_array = [];
			for(var n in p.namespaces){
				if(props.endpoints[n].list.entity.is_list === true) continue;	
				var namespace = JSON.parse(JSON.stringify(p.namespaces[n]));
				namespace.link = props.home+namespace.code;
				if(profile_keys[i] === "DF"){
					namespace.link += "/edit/"+props.userProfile.id_user;
				}
				p.namespace_array.push(namespace);
			}
		});
		setProfile(profile_array);
	},[props.userProfile,props.endpoints, props.home]);
	
	return (
		<>
			<h1 style={{marginBottom:24}}>
				<Avatar
					size={64}
					key="2"
					icon={<FontAwesomeIcon className="fa-fw" icon="user"/>} 
					style={{marginRight:"0px"}} 
					src={(props.userProfile ? props.userProfile.avatar_user : "null")}
        />&nbsp;
				{t("Welcome User",{user:props.userProfile.first_name_user})}
			</h1>
			<Row gutter={16}>
				{profile.map((p,i) => {
					return (
						<Col 
							span={8} 
							key={i} 
							style={{marginBottom:"16px"}}
						>
							<Card 
								cover={
									<img alt={t(p.duty)} src={p.avatar}/>
								}
							>
								<Meta title={t(p.duty)} />
								<List
									style={{
										height:200,
										overflowY:"auto"
									}}
									dataSource={p.namespace_array}
									renderItem={item => (
										<List.Item>
				    					<NavLink replace={true} to={item.link}>
												<FontAwesomeIcon icon={item.icon} className="fa-fw"/>
		    						    &nbsp;{t(item.name)}
    									</NavLink>
										</List.Item>
									)}
								/>	
							</Card>
						</Col>
					);
				})}
			</Row>
		</>
	);
}

export default WorkflowPage;
